import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';

import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { useGetDocumentsByNidQuery } from '../store/api-slices/documents-by-nid.endpoints';

interface UseDocumentsHistoryByNidParams {
  nid?: string;
}

export const useDocumentsHistoryByNid = ({
  nid,
}: UseDocumentsHistoryByNidParams) => {
  const country = useSelector(getCountry);

  const queryArg = !country || !nid ? skipToken : { country, nid };

  const result = useGetDocumentsByNidQuery(queryArg);
  const data = result.data ?? [];

  return { ...result, data, nid };
};



